import { addWeeks, endOfWeek, format, startOfWeek, subWeeks } from 'date-fns';
import { useContext } from 'react';
import { CalenderContext, CalenderContextType } from './CalenderContext';
import { MdChevronLeft, MdChevronRight, MdOutlineDateRange } from 'react-icons/md';
export default function WeekChanger() {
  const { today, updateToday } = useContext(CalenderContext) as CalenderContextType;
  return (
    <div className={`w-full flex items-center py-2`}>
      <div className="w-full flex items-center gap-4">
        <div className="flex items-center gap-2">
          <div
            onClick={() => updateToday(subWeeks(today, 1))}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-neutralBlue2 border border-neutralBlue1 p-2 cursor-pointer"
          >
            {/* <Icon name="chevron-left" className="" /> */}
            <MdChevronLeft className="text-base" />
          </div>
          <p className="text-sm">{format(startOfWeek(today), 'LLL d y')}</p>-
          <p className="text-sm">{format(endOfWeek(today), 'LLL d y')}</p>
          <div
            onClick={() => updateToday(addWeeks(today, 1))}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-neutralBlue2 border border-neutralBlue1 p-2 cursor-pointer"
          >
            {/* <Icon name="chevron-right" className="w-4 h-4" /> */}
            <MdChevronRight className="text-base" />
          </div>
        </div>

        <button
          onClick={() => updateToday(startOfWeek(new Date()))}
          className="w-max flex items-center justify-between gap-2 p-2 bg-neutralBlue2 rounded-md"
        >
          {/* <Icon name="calender" className="w-4 h-4" /> */}
          <MdOutlineDateRange className="text-base" />
          <p className="w-full text-sm">Today</p>
        </button>
      </div>
    </div>
  );
}
